#import "../fragments/ai-email-template.graphql"

mutation GenerateAiEmailFromTemplate($input: AiEmailTemplateGenerateFromTemplateInput!) {
    aiEmailTemplateGenerateFromTemplate(input: $input) {
        campaign {
            ...AiEmailTemplate
        }
    }
}
